import { __styles, mergeClasses, shorthands } from '@griffel/react';
import { tokens } from '@fluentui/react-theme';
export const accordionPanelClassNames = {
  root: 'fui-AccordionPanel'
};
/**
 * Styles for the root slot
 */
const useStyles = /*#__PURE__*/__styles({
  root: {
    B6of3ja: "f1hu3pq6",
    t21cq0: ["fkujibs", "f199hnxi"],
    jrapky: "f19f4twv",
    Frg6f3: ["f199hnxi", "fkujibs"]
  }
}, {
  d: [".f1hu3pq6{margin-top:0;}", ".fkujibs{margin-right:var(--spacingHorizontalM);}", ".f199hnxi{margin-left:var(--spacingHorizontalM);}", ".f19f4twv{margin-bottom:0;}"]
});
/** Applies style classnames to slots */
export const useAccordionPanelStyles_unstable = state => {
  const styles = useStyles();
  state.root.className = mergeClasses(accordionPanelClassNames.root, styles.root, state.root.className);
  return state;
};
//# sourceMappingURL=useAccordionPanelStyles.styles.js.map